var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnknownDocument = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 29,
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7785AD",
  fillRule: "evenodd",
  d: "M3.905.237h20.25c.895 0 1.753.369 2.386 1.025.633.657.988 1.547.988 2.475v21c0 .929-.355 1.819-.988 2.475a3.315 3.315 0 0 1-2.387 1.025H3.904a3.315 3.315 0 0 1-2.386-1.025 3.567 3.567 0 0 1-.988-2.475v-21c0-.928.355-1.818.988-2.475A3.315 3.315 0 0 1 3.905.237Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.777 18.53H4.254a.424.424 0 0 1-.304-.132.456.456 0 0 1-.126-.316v-7.26a.44.44 0 0 1 .43-.447h2.523c2.37 0 3.676 1.444 3.676 4.065 0 2.638-1.307 4.09-3.676 4.09Zm-.876-1.91h.748c.833 0 1.687-.257 1.687-2.164 0-1.925-.9-2.17-1.687-2.17H5.9v4.335ZM14.816 18.53l.333-.067c1.839-.314 2.84-1.714 2.84-4.023 0-2.294-1.002-3.687-2.84-3.998l-.332-.067c-.086 0-.17.002-.252.006l-.071-.003a5.668 5.668 0 0 0-.181-.003l-.333.067c-1.838.311-2.839 1.704-2.839 3.998 0 2.309 1 3.71 2.84 4.023l.332.067c.085 0 .17-.002.252-.006.082.004.166.006.252.006Zm-.251-1.932c.694-.094 1.307-.526 1.307-2.142 0-1.619-.637-2.05-1.307-2.146-.67.096-1.308.527-1.308 2.146 0 1.616.613 2.048 1.308 2.142Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.216 10.446h1.844v1.911h-1.716c-.786 0-1.687.245-1.687 2.17 0 1.908.854 2.165 1.687 2.165h1.716v1.91h-1.844c-2.37 0-3.676-1.453-3.676-4.09 0-2.622 1.307-4.066 3.676-4.066Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnknownDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unknown-document.ec74faf95e70d7372bcb84bfb1ffe301.svg";